import PropTypes from 'prop-types';
import { cn } from '@utils/general';
import { ImageDictionary, ImageKeys } from './dictionary';

const Image = ({ imgKey, className, ...rest }) => {
  if (ImageDictionary[imgKey]) {
    return (
      <img
        src={ImageDictionary[imgKey].src}
        alt={ImageDictionary[imgKey].alt}
        className={cn('cursor-pointer', className)}
        {...rest}
      />
    );
  }

  console.error(`Image '${imgKey}' not found in ImageDictionary.`);
  return <img alt="undefined" />;
};

Image.defaultProps = {
  className: '',
};

Image.propTypes = {
  className: PropTypes.string,
  imgKey: PropTypes.oneOf(Object.keys(ImageKeys)).isRequired,
};

export default Image;
